import React from "react";
import { connect } from "react-redux";
import * as echarts from "echarts";
import {supplierDebtsPieEchart} from "../../Data/Charts";

class DebtsBySupplierPieChart extends React.Component {
  componentDidMount() {
    this.chartPlace();
  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.supplierDebtsChartData !== this.props.supplierDebtsChartData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const {supplierDebtsChartData} = this.props

    const pieChartData = supplierDebtsChartData.map(item => {
      const remaining = item.remaining_amount;
      const collected = item.total_receivable_amount - remaining;
      return {
        name: `${item.customer_name} ${item.customer_surname}`,
        value: remaining,
        total_amount: item.total_receivable_amount,
        remaining_amount: remaining,
        collected_amount: collected
      };
    });

    const optionPieEchart = supplierDebtsPieEchart(pieChartData);

    var chartDom = document.getElementById("DebtsBySupplierPieChart");
    var myChart = echarts.init(chartDom);
    var option;
    option = optionPieEchart;

    option && myChart.setOption(option);
  };
  render() {
    return (
      <div>

          <div className="body">
            <div id="DebtsBySupplierPieChart" style={{ height: 300 }}></div>
            {/* <ReactEcharts
                        option={optionPieEchart}
                        opts={{renderer: 'svg'}} // use svg to render the chart.
                    /> */}
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  supplierDebtsChartData: state.analyticalReducer.supplierDebtsChartData,
});

export default connect(mapStateToProps, {})(DebtsBySupplierPieChart);
